<div class="footer">
  <div class="container">
    <div class="footer-top-container">
      <div class="row no-glutter flex-column flex-md-row mx-0">
        <div class="col-12 col-md mb-4 mb-md-0 px-0">
          <div class="links">
          <a
              href="https://www.enex.cl/promociones/"
              class="mb-3 mb-md-0"
              >Bases Legales</a
            >
            <a
              href="mailto: hablemos@enex.cl"
              class="mb-3 mb-md-0"
              ><img style="width:14px;" class="mr-2" src="./assets/icons/fontawesome/envelope-regular.svg">hablemos@enex.cl</a
            >
            <a
              href="tel:6003502000"
              class="mb-4 mb-md-0"
              ><img style="width:14px;" class="mr-2" src="./assets/icons/fontawesome/phone-solid.svg">600 350 2000</a
            >
          </div>
        </div>
        <div
          class="
            col-12 col-md-3
            d-flex
            justify-content-center justify-content-md-end
          "
        >
          <div class="social-content">
            <span
              style="cursor: pointer"
              (click)="goTo('https://twitter.com/enex_chile')"
              class="icon-Twitter mr-4"
            ></span>
            <span
              style="cursor: pointer"
              (click)="goTo('https://www.youtube.com/user/enexchile')"
              class="icon-Youtube mr-4"
            ></span>
            <span
              style="cursor: pointer"
              (click)="goTo('https://www.linkedin.com/company/enex/')"
              class="icon-Linkedin"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom-container">
      <div class="row flex-column align-items-center flex-md-row">
        <div class="col-12 col-md-8 px-0 mb-5 mb-md-0">
          <div class="logos-content">
            <div
              class="
                row
                d-flex
                align-items-center
                justify-content-center justify-content-md-start
                mb-3 mb-md-0
                p-0
              "
            >
              <div class="col-6 col-md-4 logo enex-shell"></div>

              <div class="col-5 col-md-2 logo shell-lubs-blanco"></div>
              <div class="col-3 col-md-2 logo shell-card-blanco"></div>
              <div class="col-3 col-md-2 logo enex-express-blanco"></div>
              <div class="col-3 col-md-2 logo enex-directo-blanco"></div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 d-flex justify-content-center justify-content-md-end">
          <p class="help-text mb-0  text-center text-md-right">
            ©Copyright 1919-2022 Enex S.A. <br/>
Todos los derechos reservados
          </p>
        </div>
      </div>
    </div>
  </div>
</div>



<ng-template>
  <div class="logos-content">
    <div
      class="
        col col-md-auto
        d-flex
        justify-content-center
        align-items-center
        mb-3 mb-md-0
        p-0
      "
    >
      <div class="logo enex-blanco mr-2 mr-md-4"></div>
      <div class="logo shell-lubs-blanco mr-2 mr-md-4"></div>
      <div class="logo shell-card-blanco mr-md-4"></div>
    </div>
    <div class="col col-md-auto d-flex justify-content-center align-items-center p-0">
      <div class="logo enex-express-blanco mr-2 mr-md-4"></div>
      <div class="logo enex-directo-blanco mr-2 mr-md-4"></div>
    </div>
  </div>
</ng-template>
